import React from 'react';
import styled from 'styled-components';

import {type ChallengeContext} from 'web-app/react/login/models';
import ContextChallenge from 'web-app/react/routes/context-challenge/context-challenge';
import {Flex} from 'web-app/react/components/layout/layout';

interface InputProps {
    challengeContext: ChallengeContext;
    onCancel: VoidFunction;
    redirectUrl?: string;
    loginTLD?: string;
    email: string;
}

const Backdrop = styled(Flex)`
    background-color: ${props => props.theme.mf.colorPalette.p50};
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`;

const ChallengeContextWrapper: React.FC<React.PropsWithChildren<InputProps>> = props => {
    const {challengeContext, onCancel, redirectUrl, loginTLD, email} = props;

    return (
        <Backdrop justify="center" align="center">
            <ContextChallenge
                challenge={challengeContext}
                onCancel={onCancel}
                redirectUrl={redirectUrl}
                loginTLD={loginTLD}
                email={email}
            />
        </Backdrop>
    );
};

export default ChallengeContextWrapper;
